import React, { FC } from 'react';
import { currency } from '../../utils/currency';
import { getDevelopmentSummary } from '../../utils/getDevelopmentSummary';
import { ImageCard } from '../ImageCard';

interface DevelopmentPropertyCardProps {
  property: any;
}

export const DevelopmentPropertyCard: FC<DevelopmentPropertyCardProps> = ({ property }) => {
  const { relativeUrl, address, developmentName, developmentMaxPrice, developmentMinPrice, plots, images } = property;

  const image = images.developmentImages[0];
  const { summaryText } = getDevelopmentSummary(plots);
  return (
    <ImageCard
      heading={developmentName}
      intro={`
                    ${summaryText}<br>
                    ${currency(developmentMinPrice)} - ${currency(developmentMaxPrice)}<br>
                    ${address.town} ${address.outwardCode}
                    `}
      url={relativeUrl}
      tag="NEW DEVELOPMENT"
      actionLabel="View development"
      image={image}
      imgOptions={{
        width: 400,
        height: 550,
      }}
      tagColour="accent2"
    />
  );
};
